import { Card } from "@/app/admin/_common/ui/card";
import { cn } from "@/app/_utils/cn";

export type StatTile = {
  label: string;
  value: string;
  caption?: string;
  valueClassName?: string;
};

// Spelled out rather than interpolated so Tailwind's scanner keeps these classes.
const COLUMN_CLASSES: Record<number, string> = {
  3: "sm:grid-cols-3",
  4: "sm:grid-cols-4",
  5: "sm:grid-cols-5",
};

export default function DetailStatTiles({
  tiles,
  columns = 3,
}: {
  tiles: StatTile[];
  columns?: number;
}) {
  return (
    <div className={`grid grid-cols-2 gap-2.5 ${COLUMN_CLASSES[columns] ?? COLUMN_CLASSES[3]}`}>
      {tiles.map((tile) => (
        <Card key={tile.label} className="rounded-md p-3.5 shadow-none">
          <div className="mb-1 text-[11.5px] font-medium text-muted-foreground">{tile.label}</div>
          <div className={cn("text-[21px] font-bold leading-none tracking-tight text-foreground", tile.valueClassName)}>
            {tile.value}
          </div>
          {tile.caption && (
            <div className="mt-1.5 text-[11.5px] text-muted-foreground/70">{tile.caption}</div>
          )}
        </Card>
      ))}
    </div>
  );
}
